import { Directive } from '@angular/core';
import { HostListener, Input, inject } from '@angular/core';
import { AnalyticsService } from '../services/analytics.service';

@Directive({
  selector: '[trackClick]',
  standalone: false
})
export class TrackClickDirective {

  constructor() { }

  private analytics = inject(AnalyticsService);

  @Input('trackClick') eventName!: string;
  @Input() trackingParams: Record<string, any> = {};

  @HostListener('click')
  onClick(): void {
    if (!this.eventName) return;

    const strictOrderEvents = [
      'click_view_order_individual', 
      'click_cancel_order_individual',
      'click_view_order_bulk', 
      'click_cancel_order_bulk',
      'click_download_bulk_pdf', 
      'click_view_files_automated_bulk'
    ];

    if (strictOrderEvents.includes(this.eventName)) {
      this.analytics.trackEvent(this.eventName, {
        ...this.trackingParams,
        order_id: this.trackingParams['order_id'] ?? null,
        org_id: this.trackingParams['org_id'] ?? null
      });
    } else {
      this.analytics.trackEvent(this.eventName, this.trackingParams);
    }
  }

}
